<template>
  <div class="phoneScanCode">
    <div class="top">
      <span>{{ `手机上传 ${title} 图片` }}</span>
    </div>
    <div class="imgBox">
      <van-uploader v-model="fileList" :max-count="num" multiple :after-read="(file)=>{return afterRead(file, type = 'riddleImg')}" @oversize="onOversize" accept="image/*" @delete="handleDelete">
        <div class="classData">
          <van-icon name="plus" size="16" />
          <span>本地上传</span>
        </div>
      </van-uploader>
    </div>
    <button class="nextBtn" @click="handleSubmit">提交图片</button>

    <van-popup v-model="showPopup">
      <div class="popupContent">
        <div class="title">提示</div>
        <div class="content">提交成功！请在电脑端点击完成！</div>
        <div class="btnGroup" @click="showPopup = false">好的</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Area,
  Popup,
  DatetimePicker,
  Uploader,
  Toast,
  Picker,
  ImagePreview,
} from "vant";
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
import { uploadFileToOSS } from '@/util/ossUpload'
export default {
  mixins: [listSearchMixin],
  name: 'phoneScanCode',
  components: {
    [Icon.name]: Icon,
    [Area.name]: Area,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
  },
  computed: {
    url() {
      return this.$route.query.url; // 获取路由参数
    },
    id() {
      return this.$route.query.id; // 获取路由参数
    },
    num() {
      return this.$route.query.num; // 获取路由参数
    },
    title() {
      return this.$route.query.title || ''; // 获取路由参数
    },
    isOss() {
        return this.$route.query.isOss; // 获取路由参数
    },
  },
  data() {
    return {
      showPopup: false,
      fileList: [],
      fileListCopy: [],
      imgList: [],
      imgOrderList: [],
    }
  },
  mounted() {
    document.title = '上传图片';
  },
  methods: {
    onOversize(file) {
      // Toast("文件大小不能超过 500kb");
    },
    afterRead(file, type) {
      this.fileListCopy = Array.isArray(file) ? file : [file];
      // let t
      this.fileListCopy.forEach((item) => {
        item.status='uploading'
        item.message = '上传中...'
        const isLt = item.file.size / 1024 / 1024 < 10
        if (!isLt) {
            this.handleDelete(item, 'upIng')
            Toast(`上传图片大小不能超过 10 MB!`);
            item.status = "done ";
            return
        }
        // t = setTimeout(() => {
        //   item.status = 'failed'
        //   item.message = '请求超时'
        // }, 20000)

        let self = this;
        if (this.isOss == 1) { // // 阿里云 上传
          let isLt2M = item.file.size / 1024 / 1024; // 判定图片大小
          const compress = isLt2M <= 0.2 ? 1 :
                        isLt2M <= 2 ? 0.7 :
                        isLt2M <= 4 ? 0.5 :
                        isLt2M <= 6 ? 0.4 :
                        0.3;
          let image = new Image(), resultBlob = "";
          image.src = URL.createObjectURL(item.file);
          image.onload = async () => {
            resultBlob = compress == 1 ? item.file : self.compressUpload(image, item.file, compress);
            self.aliyunHandle(item.file, resultBlob, item); // 阿里云 上传
          };
          return 
        }
        let formData = new FormData();
        formData.append("file", this.dataURLtoFileFun(item.content, item.file.name));
        let params = {
          url: api.upload,
          method: "POST",
          contentType: "multipart/form-data",
          data: formData,
        };
        self.sendReq(params, (res) => {
          if (res.code == 200) {
            this.imgOrderList.push({ url: res.url, fileName: res.fileName });
            item.status = 'done '
            if (this.imgOrderList.length == this.fileListCopy.length) { // 最后一个文件上传完成
              this.orderHandle(this.imgOrderList, this.fileListCopy)
            }
            // clearTimeout(t)
          } else {
            item.status = 'failed'
            // clearTimeout(t)
            Toast(res.msg);
          }
        },(err)=>{
          item.status = 'failed'
          item.message = '请求超时'
        });
      });
    },
    // 阿里云 上传图片
    async aliyunHandle (file, resultBlob, item) {
      const res = await uploadFileToOSS(file, resultBlob)
      if (res.status == 200) {
        this.imgOrderList.push({ url: res.url, newName: res.name, fileName: res.fileName });
        item.status = 'done '
        if (this.imgOrderList.length == this.fileListCopy.length) { // 最后一个文件上传完成
            this.orderHandle(this.imgOrderList, this.fileListCopy)
        }
      } else {
        item.status = 'failed'
        Toast('上传失败');
      }
    },
    /* 图片压缩方法-canvas压缩  根据画质压缩图片 */
    compressUpload(image, file, quality) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let { width, height } = image;
      canvas.width = width;
      canvas.height = height;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);
      const type = file.type ? (file.type == 'image/png' ? 'image/jpeg' : file.type) : 'image/jpeg';
      let base64 = canvas.toDataURL(type, quality);
      // 压缩后调用方法进行base64转Blob
      const boldFile = this.base64ToBlob(base64, type);
      return  boldFile;
      canvas = null;
    },
    // base64转Blob
    base64ToBlob (base64, contentType = '') {
      // 去除Base64字符串的前缀
      const cleanedBase64 = base64.split(',')[1] || base64;
      // 对Base64字符串进行解码
      const byteCharacters = atob(cleanedBase64);
      // 将解码后的二进制字符串转换为Uint8Array
      const byteArrays = [];
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
      }
      const byteArray = new Uint8Array(byteArrays);

      // 创建Blob对象
      return new Blob([byteArray], { type: contentType });
    },
    dataURLtoFileFun(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime,
      });
    },
    orderHandle (arr1, arr2) {
      this.$nextTick(() => {
        this.imgList = this.imgList.concat(arr2.map(item => arr1.find(item1 => item.file.name == item1.fileName).url));
        this.imgOrderList = [];
      })
    },
    // 删除图片
    handleDelete (file, type) {
      const index = this.fileListCopy.indexOf(file); // 获取文件在 fileList 中的索引
      if (index > -1) {
        this.fileListCopy.splice(index, 1);
        this.imgList.splice(index, 1); // 删除图片
        if (type === 'upIng') this.fileList.splice(index, 1); // 删除图片
      }
    },
    // 提交
    handleSubmit () {
      if (this.imgList.length == 0) return Toast('请上传图片');
      let self = this;
      const data = { filesId: this.id, filesPath: this.imgList.join(',') }
      const params = {
        url: api.updateFiles,
        method: "put",
        data: data,
        authorization: this.url,
      };
      self.sendReq(params, (res) => {
        if (res.code == 200) {
          this.showPopup = true;
          this.fileList = [];
          this.fileListCopy = [];
          this.imgList = [];
          this.imgOrderList = [];
        }
      });
    },
  }
}
</script>

<style>
.phoneScanCode .imgBox .van-uploader__preview-image {
  width: 105px;
  height: 105px;
}
.phoneScanCode .imgBox .van-uploader__preview-image .van-image__img {
  border-radius: 10px;
}
.phoneScanCode .imgBox .van-uploader__preview-delete {
  width: 18px;
  height: 18px;
  border-radius: 0 10px 0 12px;
}
.phoneScanCode .imgBox .van-uploader__preview-delete .van-uploader__preview-delete-icon {
  top: 0;
  right: 0;
}
.phoneScanCode .imgBox .van-uploader__mask {
  border-radius: 10px;
}
</style>
<style lang="scss" scoped>
.phoneScanCode {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  background: #F3F7FA;
  padding: 0 20px;
  .top {
    height: 44px;
    line-height: 44px;
    color: #111111;
  }


  .nextBtn {
    width: 100%;
    height: 40px;
    background: #0065FF;
    border-radius: 10px;
    margin-top: 20px;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
  }

  .classData {
    width: 105px;
    height: 105px;
    font-size: 10px;
    color: #666666;
    border-radius: 10px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > span {
      margin-top: 2px;
    }
  }

  .van-popup.van-popup--center {
    border-radius: 10px;
    width: calc(100% - 30px);
  }
  .popupContent {
    padding: 20px 0;
    box-shadow: 0px 0px 4px 0px rgba(1,142,233,0.1);
    .title {
      font-size: 20px;
      font-weight: 500;
      color: #111111;
      text-align: center;
    }
    .content {
      font-size: 14px;
      color: #999999;
      margin-top: 20px;
      text-align: center;
      padding-bottom: 20px;
      border-bottom: 1px solid #DADADA;
    }
    .btnGroup {
      text-align: center;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 500;
      color: #0065FF;
      cursor: pointer;
    }
  }
}


</style>


// WEBPACK FOOTER //
// src/views/moblie/phoneScanCode.vue